module.exports = __webpack_public_path__ + "img/logoLight.8979555c.svg";